// Decyzon — tiny structured-data injector. Mounts a <script type="application/ld+json">
// into <head> so Googlebot, Bingbot, GPTBot, PerplexityBot, etc. see it on first crawl.
// One instance per schema. Cleans itself up on unmount.

import { useEffect } from "react";

interface Props {
  id: string;            // unique id so multiple schemas can coexist on one page
  data: Record<string, unknown> | Array<Record<string, unknown>>;
}

export default function JsonLd({ id, data }: Props) {
  useEffect(() => {
    const elId = `ld-${id}`;
    let el = document.getElementById(elId) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = elId;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const existing = document.getElementById(elId);
      if (existing) existing.remove();
    };
  }, [id, data]);
  return null;
}
